import { Controller } from "@hotwired/stimulus"

// Reading time clock: hand rotates once on load (1s), then stops. Passive animation.
export default class extends Controller {
  connect() {
    // CSS handles the single rotation via .icon-clock-hand animation. No JS needed.
  }
}
